import { gql } from "@apollo/client";

const GET_COSES = gql`
  query coses(
    $page: Int!
    $limit: Int
    $optionalCosesFilters: OptionalCosesFilters
    $sortBy: String
  ) {
    coses(
      page: $page
      limit: $limit
      optionalCosesFilters: $optionalCosesFilters
      sortBy: $sortBy
    ) {
      data {
        type
        id
        self_link
        title
        created
        changed
        langcode
        drupal_internal__nid
        drupal_internal__vid
        revision_timestamp
        revision_log
        status
        promote
        sticky
        default_langcode
        revision_translation_affected
        field_activity_type
        field_arrival_date
        field_comment
        field_departure_date
        field_omobility_id
        field_receiving_academic_year_id
        field_receiving_hei_id
        field_sending_academic_term_ewp
        field_sending_hei_id
        field_student_date_of_birth
        field_student_email
        field_student_family_name
        field_student_given_names
        field_student_global_id
      }
      nextLink
      page
      count
    }
  }
`;

export default GET_COSES;
